<template>
  <div id="app">

    <!--    <div id="nav">-->
    <!--      <router-link to="/">Home</router-link> |-->
    <!--      <router-link to="/about">About</router-link>-->
    <!--    </div>-->
    <router-view />

  </div>
</template>

<!--  高德地图定位key因为fkc的定位要求不是过于精准所以用的私人key_zhw-->
<script>

// window.onload = function() {
//   document.addEventListener('touchstart', function(event) {
//     if (event.touches.length > 1) {
//       event.preventDefault()
//     }
//   })
//   document.addEventListener('gesturestart', function(event) {
//     event.preventDefault()
//   })
// }
import { Sticky, Tabbar, TabbarItem } from 'vant'
import NavBar from '@/components/NavBar'
import footers from '@/components/footer'

export default {
  name: 'Home',
  components: {
    NavBar,
    Sticky,
    Tabbar,
    footers,
    TabbarItem
  },
  data() {
    return {
      isroute: true,
      active: 0
    }
  },
  created() {
    if (this.$route.name == 'home') {
      this.isroute = true
    } else if (this.$route.name == 'orderlist') {
      this.isroute = true
    } else {
      this.isroute = false
    }
  },
  methods: {

  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
